/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKSocialButton from "components/MKSocialButton";
import MKTypography from "components/MKTypography";

// Image
//import bgImage from "assets/images/headshotSmall.png";
import bgImageNew from "assets/images/newHeadshot.png";
import unannouncedMMORPGProjectImage from "assets/images/portfolio/unannouncedMMORPGProjectImage.png";
import redfallProjectImage from "assets/images/portfolio/RedfallProjectImage.png";
import outridersProjectImage from "assets/images/portfolio/OutridersProjectImage.png";
import runeProjectImage from "assets/images/portfolio/RuneProjectImage.png";
import survivedByProjectImage from "assets/images/portfolio/SurvivedByProjectImage.png";
import jamsPrototypesProjectImage from "assets/images/portfolio/JamsPrototypesProjectImage.png";

import gamingResume from "assets/documents/Ian_Mahuta_Resume.pdf";

// mui Icons
import CloseIcon from "@mui/icons-material/Close";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";

function Portfolio() {
  const [mmoshow, mmosetShow] = useState(false);
  const toggleMmoModal = () => mmosetShow(!mmoshow);

  const [redfallshow, redfallsetShow] = useState(false);
  const toggleRedfallModal = () => redfallsetShow(!redfallshow);

  const [outridersshow, outriderssetShow] = useState(false);
  const toggleOutridersModal = () => outriderssetShow(!outridersshow);

  const [runeshow, runesetShow] = useState(false);
  const toggleRuneModal = () => runesetShow(!runeshow);

  const [sbshow, sbsetShow] = useState(false);
  const toggleSBModal = () => sbsetShow(!sbshow);

  const [jamshow, jamsetShow] = useState(false);
  const toggleJamModal = () => jamsetShow(!jamshow);

  return (
    <>
      <Grid
        item
        xs={12}
        sm={10}
        md={7}
        lg={6}
        xl={6}
        ml={{ xs: "auto", lg: 1 }}
        mr={{ xs: "auto", lg: 1 }}
      >
        <MKBox
          bgColor="secondary"
          borderRadius="xl"
          shadow="lg"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mt={{ xs: 5, sm: 5, md: 5 }}
          mb={{ xs: 5, sm: 5, md: 5 }}
          mx={3}
        >
          <MKBox
            variant="gradient"
            bgColor="info"
            coloredShadow="background"
            borderRadius="lg"
            p={2}
            mx={2}
            mt={-3}
          >
            <MKTypography variant="h1" color="background" sx={{ textAlign: "center" }}>
              Ian Mahuta
            </MKTypography>
            <MKTypography variant="h4" color="background" sx={{ textAlign: "center" }}>
              Gameplay and Tools Engineer
            </MKTypography>
            <MKTypography variant="body2" color="background" sx={{ textAlign: "center" }}>
              Madison, Wisconsin USA
            </MKTypography>
          </MKBox>
          <MKBox p={3}>
            <MKTypography variant="body2" color="primary" mb={3}>
              I am a Gameplay and Tools Engineer with 10+ years of Software Engineering experience
              developing standalone products, networked client/server systems, and database systems
              for the Information Technology and Games Industries. I&apos;ve shipped multiple indie
              and AAA titles for PC and consoles, including doing live operations with weekly
              content updates for an MMORPG. I have experience working on large and small teams in
              an Agile development environment and I am passionate about collaborating with a team
              to develop and deliver amazing products.
              <br />
              <br />
              <Grid
                container
                spacing="15%"
                columns={2}
                alignItems="center"
                display="flex"
                flexDirection="row"
                justifyContent="start"
              >
                <Grid item>
                  <MKBox p={2}>
                    <MKTypography color="default" textAlign="left">
                      <strong>Languages:</strong> C++, C#, VB.NET, Java, Python, SQL
                      <br />
                      <strong>Engines:</strong> Unreal Engine 4/5, Unity, Custom ECS Engines
                      <br />
                      <strong>Tools:</strong> Visual Studio, JIRA, Confluence, Perforce, Git, Qt
                      Framework, TeamCity, Jenkins
                      <br />
                      <strong>Additional Skills:</strong> Azure, DigitalOcean, Ruby, Rails, Node.JS,
                      MongoDB{" "}
                    </MKTypography>
                  </MKBox>
                </Grid>
                <Grid item alignItems="right" justifyContent="right">
                  <MKBox component="img" src={bgImageNew} alt="Ian Mahuta" alignItems="center" />
                </Grid>
              </Grid>
            </MKTypography>
            <center>
              <MKButton
                color="info"
                href={gamingResume}
                sx={{ mr: 3 }}
                target="_blank"
                referrerPolicy="no-referrer"
              >
                Download Resume
              </MKButton>
              <MKSocialButton
                component="a"
                href="https://www.linkedin.com/in/ian-mahuta/"
                target="_blank"
                color="linkedin"
                size="large"
                iconOnly
                circular
                sx={{ mr: 3 }}
              >
                <LinkedInIcon />
              </MKSocialButton>
              <MKSocialButton
                component="a"
                href="https://github.com/IanMahuta"
                target="_blank"
                color="github"
                size="large"
                iconOnly
                circular
              >
                <GitHubIcon />
              </MKSocialButton>
            </center>
          </MKBox>
        </MKBox>

        <MKBox
          bgColor="#b2e5cb"
          borderRadius="xl"
          shadow="lg"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mt={{ xs: 10, sm: 10, md: 10 }}
          mb={{ xs: 10, sm: 10, md: 10 }}
          mx={3}
        >
          <MKBox
            variant="gradient"
            bgColor="info"
            coloredShadow="secondary"
            borderRadius="lg"
            p={2}
            mx={2}
            mt={-3}
          >
            <MKTypography
              variant="h1"
              color="background"
              sx={{ overflowWrap: "break-word", textAlign: "center" }}
            >
              Project Portfolio
            </MKTypography>
          </MKBox>
          <MKBox p={3}>
            <MKTypography variant="body1" color="background" fontWeight="bold">
              Click a project to find out more...
            </MKTypography>
            <br />
            <center>
              <MKBox
                borderRadius="10px"
                coloredShadow="black"
                width="75%"
                shadow="lg"
                onClick={toggleMmoModal}
                overflow="hidden"
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: "0 0px 20px rgba(17, 69, 30)",
                  },
                }}
              >
                <MKBox
                  component="img"
                  src={unannouncedMMORPGProjectImage}
                  alt="Unannounced MMORPG"
                  width="100%"
                  sx={{
                    verticalAlign: "middle",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                />
              </MKBox>
              <br />
              <MKBox
                borderRadius="10px"
                coloredShadow="black"
                shadow="lg"
                onClick={toggleRedfallModal}
                overflow="hidden"
                width="75%"
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: "0 0px 20px rgba(17, 69, 30)",
                  },
                }}
              >
                <MKBox
                  component="img"
                  src={redfallProjectImage}
                  alt="Redfall"
                  width="100%"
                  sx={{
                    verticalAlign: "middle",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                />
              </MKBox>
              <br />
              <MKBox
                borderRadius="10px"
                coloredShadow="black"
                shadow="lg"
                onClick={toggleOutridersModal}
                overflow="hidden"
                width="75%"
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: "0 0px 20px rgba(17, 69, 30)",
                  },
                }}
              >
                <center>
                  <MKBox
                    component="img"
                    src={outridersProjectImage}
                    alt="Outriders"
                    width="100%"
                    sx={{
                      verticalAlign: "middle",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  />
                </center>
              </MKBox>
              <br />
              <MKBox
                borderRadius="10px"
                coloredShadow="black"
                shadow="lg"
                onClick={toggleRuneModal}
                overflow="hidden"
                width="75%"
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: "0 0px 20px rgba(17, 69, 30)",
                  },
                }}
              >
                <center>
                  <MKBox
                    component="img"
                    src={runeProjectImage}
                    alt="Rune II"
                    width="100%"
                    sx={{
                      verticalAlign: "middle",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  />
                </center>
              </MKBox>
              <br />
              <MKBox
                borderRadius="10px"
                coloredShadow="black"
                shadow="lg"
                onClick={toggleSBModal}
                overflow="hidden"
                width="75%"
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: "0 0px 20px rgba(17, 69, 30)",
                  },
                }}
              >
                <center>
                  <MKBox
                    component="img"
                    src={survivedByProjectImage}
                    alt="SurvivedBy"
                    width="100%"
                    sx={{
                      verticalAlign: "middle",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  />
                </center>
              </MKBox>
              <br />
              <MKBox
                borderRadius="10px"
                coloredShadow="black"
                shadow="lg"
                onClick={toggleJamModal}
                overflow="hidden"
                width="75%"
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    boxShadow: "0 0px 20px rgba(17, 69, 30)",
                  },
                }}
              >
                <center>
                  <MKBox
                    component="img"
                    src={jamsPrototypesProjectImage}
                    alt="Game Jam Projects"
                    width="100%"
                    sx={{
                      verticalAlign: "middle",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  />
                </center>
              </MKBox>
            </center>
            <br />
          </MKBox>
        </MKBox>

        <Modal
          open={mmoshow}
          onClose={toggleMmoModal}
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={6}
          sx={{
            display: "grid",
            placeItems: "center",
            overflow: "scroll",
          }}
        >
          <Slide direction="down" in={mmoshow} timeout={500}>
            <MKBox
              position="relative"
              width="75vw"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="info"
              variant="gradient"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="top" justifyContent="right" pt={2} pr={2}>
                <CloseIcon
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                  onClick={toggleMmoModal}
                  color="default"
                />
              </MKBox>
              <Grid
                container
                spacing={0}
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                }}
              >
                <Grid item>
                  <MKBox display="flex" flexDirection="column" alignItems="top" p={2}>
                    <MKTypography variant="h1" color="default">
                      Unannounced MMORPG
                    </MKTypography>
                  </MKBox>
                </Grid>
                <Grid item>
                  <MKBox
                    display="flex"
                    flexDirection="column"
                    alignItems="top"
                    justifyContent="right"
                    p={2}
                  >
                    <MKTypography variant="body2" fontWeight="regular" color="default">
                      <strong>Genre:</strong> New IP MMORPG
                      <br />
                      <strong>My Role:</strong> Gameplay Engineer
                      <br />
                      <strong>Tools:</strong> Custom Entity-Component-System Game Engine (Native
                      C++)
                    </MKTypography>
                  </MKBox>
                </Grid>
              </Grid>
              <hr color="#063c37" />
              <MKBox p={2} bgColor="#b2e5cb">
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  About:
                </MKTypography>
                <MKTypography variant="body2" color="primary">
                  This title was a new IP MMORPG being developed by ZeniMax Online Studios.
                </MKTypography>
                <br />
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  My Contributions:
                </MKTypography>
                <MKTypography variant="body2" color="primary" pl={3}>
                  <ul>
                    <li>
                      Used C++ and the Qt Framework to build custom tools for creating and editing
                      game assets. Managed and maintined tooling for exporting asset data into asset
                      structures and generated code to be used in engine.
                    </li>
                    <li>
                      Implemented engine functionality for exporting asset changes made in engine to
                      external tools. Implemented functionality for hotreloading the running engine
                      with updated assets from tools.
                    </li>
                    <li>
                      Architechted and implemented custom workflows for the development of weapons
                      and combat systems.
                    </li>
                    <li>
                      Implemented multiple combat aim assist systems that worked in tandem to create
                      a cohesive gameplay experience while also being editable in real time by
                      designers and players.
                    </li>
                    <li>
                      Implemented a dynamic camera collision detection and avoidance system; this
                      sytem gently adjusted camera distance to smoothly move away from collision as
                      the player moved around the world.
                    </li>
                    <li>
                      Mentored and onboarded multiple Junior Engineers and assisted with planning
                      and designing solutions for their tasks.
                    </li>
                  </ul>
                </MKTypography>
              </MKBox>
              <hr color="#063c37" />
              <MKBox display="flex" justifyContent="center" p={1.5}>
                <MKButton color="info" onClick={toggleMmoModal}>
                  close
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

        <Modal
          open={redfallshow}
          onClose={toggleRedfallModal}
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={6}
          sx={{
            display: "grid",
            placeItems: "center",
            overflow: "scroll",
          }}
        >
          <Slide direction="down" in={redfallshow} timeout={500}>
            <MKBox
              position="relative"
              width="75vw"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="info"
              variant="gradient"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="top" justifyContent="right" pt={2} pr={2}>
                <CloseIcon
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                  onClick={toggleRedfallModal}
                  color="default"
                />
              </MKBox>
              <Grid
                container
                spacing={0}
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                }}
              >
                <Grid item>
                  <MKBox display="flex" flexDirection="column" alignItems="top" p={2}>
                    <MKTypography variant="h1" color="default">
                      Redfall
                    </MKTypography>
                  </MKBox>
                </Grid>
                <Grid item>
                  <MKBox
                    display="flex"
                    flexDirection="column"
                    alignItems="top"
                    justifyContent="right"
                    p={2}
                  >
                    <MKTypography variant="body2" fontWeight="regular" color="default">
                      <strong>Genre:</strong> First Person Shooter
                      <br />
                      <strong>Shipped:</strong> PC/Xbox Series; May 2023
                      <br />
                      <strong>My Role:</strong> Gameplay Programmer
                      <br />
                      <strong>Tools:</strong> Unreal Engine (Native C++)
                    </MKTypography>
                  </MKBox>
                </Grid>
              </Grid>
              <hr color="#063c37" />
              <MKBox p={2} bgColor="#b2e5cb">
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  About:
                </MKTypography>
                <MKTypography variant="body2" color="primary">
                  Redfall is an open-world, co-op FPS from Arkane Austin, the award-winning team
                  behind Prey and Dishonored. Continuing Arkane&apos;s legacy of carefully crafted
                  worlds and immersive sims, Redfall brings the studio&apos;s signature gameplay to
                  this story-driven action shooter.
                </MKTypography>
                <br />
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  My Contributions:
                </MKTypography>
                <MKTypography variant="body2" color="primary" pl={3}>
                  <ul>
                    <li>
                      Built networked NPC interaction systems for the Living World team. This
                      included dynamic distraction and patrol systems for randomly spawned NPCs in
                      the open world along with systems for scripted side mission that the player
                      could elect to take on.
                    </li>
                    <li>
                      Implemented AI combat behaviors and custom non-combat AI states. This included
                      working closely with the Animation team for getting enemies to switch into and
                      out of combat from distractions gracefully.
                    </li>
                    <li>
                      Designed and implemented a system for dynamically spawning civilian NPCs in
                      safe zones without duplicating skins on a limited set of skeletal meshes while
                      allowing the spawning to be tweakable by Designers.
                    </li>
                    <li>
                      Worked closely with Designers and Animators on implementing prop interactions
                      for players and civilian NPCs in safe zones.
                    </li>
                  </ul>
                </MKTypography>
                <br />
                <center>
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/cR8GVePOdpY?si=OAUZmM2QqtcgP0uD"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>{" "}
                </center>
              </MKBox>
              <hr color="#063c37" />
              <MKBox display="flex" justifyContent="center" p={1.5}>
                <MKButton color="#info" onClick={toggleRedfallModal}>
                  close
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

        <Modal
          open={outridersshow}
          onClose={toggleOutridersModal}
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={6}
          sx={{
            display: "grid",
            placeItems: "center",
            overflow: "scroll",
          }}
        >
          <Slide direction="down" in={outridersshow} timeout={500}>
            <MKBox
              position="relative"
              width="75vw"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="info"
              variant="gradient"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="top" justifyContent="right" pt={2} pr={2}>
                <CloseIcon
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                  onClick={toggleOutridersModal}
                  color="default"
                />
              </MKBox>
              <Grid
                container
                spacing={0}
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                }}
              >
                <Grid item>
                  <MKBox display="flex" flexDirection="column" alignItems="top" p={2}>
                    <MKTypography variant="h1" color="default">
                      Outriders
                    </MKTypography>
                  </MKBox>
                </Grid>
                <Grid item>
                  <MKBox
                    display="flex"
                    flexDirection="column"
                    alignItems="top"
                    justifyContent="right"
                    p={2}
                  >
                    <MKTypography variant="body2" fontWeight="regular" color="default">
                      <strong>Genre:</strong> Third Person Shooter
                      <br />
                      <strong>Shipped:</strong> PC/Playstaion 4/Playstation 5/Xbox One/Xbox Series;
                      May 2021
                      <br />
                      <strong>My Role:</strong> Gameplay Programmer
                      <br />
                      <strong>Tools:</strong> Unreal Engine (Native C++)
                    </MKTypography>
                  </MKBox>
                </Grid>
              </Grid>
              <hr color="#063c37" />
              <MKBox p={2} bgColor="#b2e5cb">
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  About:
                </MKTypography>
                <MKTypography variant="body2" color="primary">
                  Outriders is a 1-3 player co-op RPG shooter set in an original, dark and desperate
                  sci-fi universe developed by People Can Fly.
                </MKTypography>
                <br />
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  My Contributions:
                </MKTypography>
                <MKTypography variant="body2" color="primary" pl={3}>
                  <ul>
                    <li>
                      Implemented multiple boss encounters based on Designer specifications. This
                      included building boss Behavior Trees, implementing combat abilities with the
                      Gameplay Ability System, and working with the Animation team on ensuring boss
                      state transitions happen smoothly.
                    </li>
                    <li>Built a reusable telegraph system used for multiple encounters.</li>
                  </ul>
                </MKTypography>
                <br />
                <center>
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/dqB46adBC-o?si=pQyAYPCpFJ3rTQGD"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>{" "}
                </center>
              </MKBox>
              <hr color="#063c37" />
              <MKBox display="flex" justifyContent="center" p={1.5}>
                <MKButton color="info" onClick={toggleOutridersModal}>
                  close
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

        <Modal
          open={runeshow}
          onClose={toggleRuneModal}
          sx={{
            display: "grid",
            placeItems: "center",
            overflow: "scroll",
          }}
        >
          <Slide direction="down" in={runeshow} timeout={500}>
            <MKBox
              position="relative"
              width="75vw"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="info"
              variant="gradient"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="top" justifyContent="right" pt={2} pr={2}>
                <CloseIcon
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                  onClick={toggleRuneModal}
                  color="default"
                />
              </MKBox>
              <Grid
                container
                spacing={0}
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                }}
              >
                <Grid item>
                  <MKBox display="flex" flexDirection="column" alignItems="top" p={2}>
                    <MKTypography variant="h1" color="default">
                      Rune 2
                    </MKTypography>
                  </MKBox>
                </Grid>
                <Grid item>
                  <MKBox
                    display="flex"
                    flexDirection="column"
                    alignItems="top"
                    justifyContent="right"
                    p={2}
                  >
                    <MKTypography variant="body2" fontWeight="regular" color="default">
                      <strong>Genre:</strong> 3D Open-World Action RPG
                      <br />
                      <strong>Shipped:</strong> PC; 2019
                      <br />
                      <strong>My Role:</strong> Gameplay Programmer
                      <br />
                      <strong>Tools:</strong> Unreal Engine (UMG, Blueprints)
                    </MKTypography>
                  </MKBox>
                </Grid>
              </Grid>
              <hr color="#063c37" />
              <MKBox p={2} bgColor="#b2e5cb">
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  About:
                </MKTypography>
                <MKTypography variant="body2" color="primary">
                  Rune 2 is a sandbox, open-world RPG set in a dangerous Norse universe during the
                  end of days. A highly anticipated follow-up to Rune Classic, the team&apos;s hit
                  action-adventure game, Rune places players in the middle of an epic battle where
                  gods, beasts, and the last remaining humans struggle to survive. By pledging
                  allegiance to one of the Norse gods, players gain favor and special abilities to
                  aid them as they raid enemy villages, fight the undead in brutal melee combat,
                  sail to new lands, and craft powerful weapons to complete the goals of their god
                  and conclude Ragnarok.
                </MKTypography>
                <br />
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  My Contributions:
                </MKTypography>
                <MKTypography variant="body2" color="primary" pl={3}>
                  <ul>
                    <li>
                      Implemented multiple enemy AIs using Behavior Trees and the Gameplay Ability
                      System.
                    </li>
                    <li>Worked on dynamic encounter spawning systems in the open world.</li>
                  </ul>
                </MKTypography>
                <br />
                <center>
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/iBideuSAFYc?si=eSFcliwHj3Fx8hMg"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </center>
              </MKBox>
              <hr color="#063c37" />
              <MKBox display="flex" justifyContent="center" p={1.5}>
                <MKButton color="info" onClick={toggleRuneModal}>
                  close
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

        <Modal
          open={sbshow}
          onClose={toggleSBModal}
          sx={{
            display: "grid",
            placeItems: "center",
            overflow: "scroll",
          }}
        >
          <Slide direction="down" in={sbshow} timeout={500}>
            <MKBox
              position="relative"
              width="75vw"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="info"
              variant="gradient"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="top" justifyContent="right" pt={2} pr={2}>
                <CloseIcon
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                  onClick={toggleSBModal}
                  color="default"
                />
              </MKBox>
              <Grid
                container
                spacing={0}
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                }}
              >
                <Grid item>
                  <MKBox display="flex" flexDirection="column" alignItems="top" p={2}>
                    <MKTypography variant="h1" color="default">
                      Survived By
                    </MKTypography>
                  </MKBox>
                </Grid>
                <Grid item>
                  <MKBox
                    display="flex"
                    flexDirection="column"
                    alignItems="top"
                    justifyContent="right"
                    p={2}
                  >
                    <MKTypography variant="body2" fontWeight="regular" color="default">
                      <strong>Genre:</strong> 2D Bullet-Hell Roguelite MMORPG
                      <br />
                      <strong>Shipped:</strong> PC; 2018
                      <br />
                      <strong>My Role:</strong> Gameplay Programmer
                      <br />
                      <strong>Tools:</strong> Unity 3D (C#)
                    </MKTypography>
                  </MKBox>
                </Grid>
              </Grid>
              <hr color="#063c37" />
              <MKBox p={2} bgColor="#b2e5cb">
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  About:
                </MKTypography>
                <MKTypography variant="body2" color="primary">
                  Survived By is a free to play retro-style fantasy survival MMO in which up to 100
                  players fight side-by-side in a bullet hell-style battle where permadeath is just
                  the beginning. Mankind has been pushed to the end of extinction by an otherworldly
                  corruption, but a few stalwart folk stand up and fight back. Create a character,
                  grab your weapons, and face off against the encroaching darkness.
                </MKTypography>
                <br />
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  My Contributions:
                </MKTypography>
                <MKTypography variant="body2" color="primary" pl={3}>
                  <ul>
                    <li>Implemented enemy AI behaviors and boss encounters.</li>
                    <li>
                      Implemented enemy and player projectile systems and managed weapon assets used
                      by both players and enemies. Also implemented player special abilities.
                    </li>
                    <li>
                      Designed and implemented multiple core gameplay systems, including a dynamic
                      data driven event system and a quest system.
                    </li>
                    <li>
                      Developed game code in a REST-based server/client cloud architecture using C#
                      and SQL.
                    </li>
                    <li>
                      Performed Live Operations updating the game database and deploying server
                      updates with a weekly release cadence.
                    </li>
                  </ul>
                </MKTypography>
                <br />
                <center>
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/e9gI7312OTE?si=4fdJNcm4DGzm1t2x"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </center>
              </MKBox>
              <hr color="#063c37" />
              <MKBox display="flex" justifyContent="center" p={1.5}>
                <MKButton color="info" onClick={toggleSBModal}>
                  close
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

        <Modal
          open={jamshow}
          onClose={toggleJamModal}
          sx={{
            display: "grid",
            placeItems: "center",
            overflow: "scroll",
          }}
        >
          <Slide direction="down" in={jamshow} timeout={500}>
            <MKBox
              position="relative"
              width="75vw"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              borderColor="#063c37"
              bgColor="info"
              variant="gradient"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="top" justifyContent="right" pt={2} pr={2}>
                <CloseIcon
                  fontSize="medium"
                  sx={{ cursor: "pointer" }}
                  onClick={toggleJamModal}
                  color="default"
                />
              </MKBox>
              <Grid
                container
                spacing={0}
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                }}
              >
                <Grid item>
                  <MKBox display="flex" flexDirection="column" alignItems="top" p={2}>
                    <MKTypography variant="h1" color="default">
                      Game Jams and Personal Projects
                    </MKTypography>
                  </MKBox>
                </Grid>
                <Grid item>
                  <MKBox
                    display="flex"
                    flexDirection="column"
                    alignItems="top"
                    justifyContent="right"
                    p={2}
                  >
                    <MKTypography variant="body2" fontWeight="regular" color="default">
                      <strong>Genre:</strong> Various
                      <br />
                      <strong>My Roles:</strong> Lead Programmer/Designer
                      <br />
                      <strong>Tools:</strong> Unity 3D (C#)
                    </MKTypography>
                  </MKBox>
                </Grid>
              </Grid>
              <hr color="#063c37" />
              <MKBox p={2} bgColor="#b2e5cb">
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  About:
                </MKTypography>
                <MKTypography variant="body2" color="primary">
                  I&apos;ve participated and completed various game jams and built prototypes listed
                  below. They include In Traffic (Satirical Frogger Clone for Android), Krunch (2D
                  Side Scroll Puzzle Game), Faux News (2D Satirical Simulation Game), Night Terrors
                  (2D Top Down Stealth Game), and Executive Ball Launch (3D Destruction Puzzle
                  Game). These projects were made using Unity, C# and Java.
                </MKTypography>
                <br />
                <MKTypography variant="h4" color="primary" fontWeight="bold">
                  My Contributions:
                </MKTypography>
                <MKTypography variant="body2" color="primary" pl={3}>
                  <ul>
                    <li>
                      <strong>In Traffic: </strong>Built for a Hack-a-thon, as a Frogger clone where
                      the player was unable to win. This was a solo project implemented in Java to
                      work on Android devices.
                      <br />
                      <a href="https://github.com/IanMahuta/InTraffic">View In Traffic GitHub</a>
                    </li>
                    <li>
                      <strong>Krunch: </strong>Built for a Ludum Dare with one other team member in
                      Unity with C# for the PC. Implemented enemy AI, player hiding and looting
                      mechanics. Implemented camera effects and UIs. Created some art assets.
                      <br />
                      <a href="https://loginaut.itch.io/krunch">Play Krunch on itch.io</a>
                    </li>
                    <li>
                      <strong>Faux News: </strong>Built for a Ludum Dare with a small team in Unity
                      with C# for the PC. Built a systems for importing fake news headlines into
                      engine assets.
                      <br />
                      <a href="https://github.com/LogJams/LD32">View Faux News GitHub</a>
                    </li>
                    <li>
                      <strong>Night Terrors: </strong>Built for a Ludum Dare with one other team
                      member in Unity with C# for the PC. Implemented NPC spawning, pathing and
                      awareness. Implemented scene transitions and day/night system.
                      <br />
                      <a href="https://github.com/LogJams/LD33">View Night Terrors GitHub</a>
                    </li>
                    <li>
                      <strong>Executive Ball Launch: </strong>Built as part of the MSOE Game
                      Development Club in Unity with C# for the PC. Implemented game win and loss
                      states. Created a level builder tool and built levels for the game.
                      <br />
                      <a href="https://github.com/Logiant/Executive-Ball-Launch">
                        View Executive Ball Launch GitHub
                      </a>
                    </li>
                  </ul>
                </MKTypography>
                <br />
              </MKBox>
              <hr color="#063c37" />
              <MKBox display="flex" justifyContent="center" p={1.5}>
                <MKButton color="info" onClick={toggleJamModal}>
                  close
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

        <MKBox
          bgColor="#b2e5cb"
          borderRadius="xl"
          shadow="lg"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mt={{ xs: 10, sm: 10, md: 10 }}
          mb={{ xs: 10, sm: 10, md: 10 }}
          mx={3}
        >
          <MKBox
            variant="gradient"
            bgColor="info"
            coloredShadow="secondary"
            borderRadius="lg"
            p={2}
            mx={2}
            mt={-3}
          >
            <MKTypography
              variant="h1"
              color="background"
              sx={{ overflowWrap: "break-word", textAlign: "center" }}
            >
              Experience
            </MKTypography>
          </MKBox>
          <MKBox p={3}>
            <MKTypography variant="body2" color="primary" mb={3}>
              <h3>Gameplay Engineer, Zenimax Online Studios</h3>
              <i>May 2024 – October 2025; Madison, WI.</i>
              <MKTypography variant="body2" color="primary" pl={1}>
                Delivered core gameplay and engine features within major milestones for internal
                review, corporate stakeholder review, and launch. Implemented key C++ systems and
                engine workflows used critically by other teams.
              </MKTypography>
              <br />
              <MKTypography variant="body2" color="primary" pl={3}>
                <ul>
                  <li>
                    Authored native C++ systems supporting server/client communication in modern C++
                    codebases, including combat interaction systems
                  </li>
                  <li>
                    Authored multiple native C++ aim assist systems that were tweakable per weapon
                    by designers and globally tweakable by users
                  </li>
                  <li>
                    Authored native C++ camera collision detection system to create a reactive
                    camera that automatically avoided collision as the player moved
                  </li>
                  <li>
                    Wrote supporting unit test suites using Microsoft Unit Testing Framework for C++
                  </li>
                  <li>
                    Wroked collaboratively with a team spanning multiple time zones and continents
                  </li>
                </ul>
              </MKTypography>
              <br />
              <br />
              <h3>Game Programmer, Roundhouse Studios</h3>
              <i>Nov 2019 – May 2024; Madison, WI.</i>
              <MKTypography variant="body2" color="primary" pl={1}>
                Built several gameplay systems in native C++ within Unreal and proprietary game
                engines. Worked with animation and design teams on dynamic actions and Living World
                systems. Implemented AI behaviors and interactions. Built internal tools using C++
                and Qt Framework to facilitate the work of other developers.
              </MKTypography>
              <br />
              <MKTypography variant="body2" color="primary" pl={3}>
                <ul>
                  <li>
                    Developed AI awareness and abilities in native C++ within Unreal Engine for
                    Redfall (PC/Xbox Series, 2023)
                  </li>
                  <li>
                    Designed and implemented friendly NPC spawning systems in native C++ within
                    Unreal Engine for Redfall (PC/Xbox Series, 2023)
                  </li>
                  <li>
                    Developed non-combat AI interactions, including environmental and prop
                    interactions, in native C++ within Unreal Engine for Redfall (PC/Xbox Series,
                    2023)
                  </li>
                  <li>
                    Implemented data stuctures at the Engine level for use by other developers for a
                    proprietary game engine in C++
                  </li>
                  <li>
                    Developed asset creation pipeline and supporting internal tools with C++ and Qt
                    Framework for a proprietary game engine
                  </li>
                  <li>Mentored and onboarded Junior Engineers</li>
                </ul>
              </MKTypography>
              <br />
              <br />
              <h3>Gameplay Programmer, Human Head Studios</h3>
              <i>August 2017 – Nov 2019; Madison, WI.</i>
              <MKTypography variant="body2" color="primary" pl={1}>
                Contributed to the development and release of online games with over 1 million users
                in Unreal Engine and Unity. Developed AI and combat systems for multiple titles.
                Performed live operations and owned the process of server management. Developed
                multiple core gameplay systems for an MMORPG.
              </MKTypography>
              <br />
              <MKTypography variant="body2" color="primary" pl={3}>
                <ul>
                  <li>
                    Built boss encounters, Behavior Trees and native combat abilities for Outriders
                    (PC/Playstation/Xbox 2021)
                  </li>
                  <li>Built AI behaviors and spawning systems for Rune II (PC 2019)</li>
                  <li>
                    Developed server/client player gameplay abilities for SurvivedBy (PC 2018)
                  </li>
                  <li>
                    Implemented server/client game systems in C# to handle dynamic/seasonal events,
                    quests, crafting and combat for SurvivedBy (PC 2018)
                  </li>
                  <li>
                    Managed the server and database deployment process for live operations on
                    Survived By (PC 2018)
                  </li>
                </ul>
              </MKTypography>
              <br />
              <br />
              <h3>Programmer Analyst Intern / Programmer Analyst I, Infosoft Group</h3>
              <i>May 2015 – August 2017; Milwaukee, WI.</i>
              <MKTypography variant="body2" color="primary" pl={1}></MKTypography>
              <br />
              <MKTypography variant="body2" color="primary" pl={3}>
                <ul>
                  <li>Wrote customer specific applications using VB.NET</li>
                  <li>
                    Managed and mainained multiple systems that interfaced with government job
                    boards to facilitate and automate job postings
                  </li>
                  <li>
                    Used SQL databases to manage customer data and built custom queries used by
                    multiple applications
                  </li>
                  <li>Built internal metrics dashboard</li>
                  <li>Mentored and managed multiple interns</li>
                </ul>
              </MKTypography>
            </MKTypography>
          </MKBox>
        </MKBox>

        <MKBox
          bgColor="#b2e5cb"
          borderRadius="xl"
          shadow="lg"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mt={{ xs: 10, sm: 10, md: 10 }}
          mb={{ xs: 10, sm: 10, md: 10 }}
          mx={3}
        >
          <MKBox
            variant="gradient"
            bgColor="info"
            coloredShadow="secondary"
            borderRadius="lg"
            p={2}
            mx={2}
            mt={-3}
          >
            <MKTypography
              variant="h1"
              color="background"
              sx={{ overflowWrap: "break-word", textAlign: "center" }}
            >
              Credits
            </MKTypography>
          </MKBox>
          <MKBox p={3}>
            <MKTypography variant="body2" color="primary" mb={3}>
              <strong>Unannounced MMORPG</strong> (PC/Consoles; Unreleased)
              <br />
              <strong>Redfall</strong> (PC/Xbox Series; May 2023)
              <br />
              <strong>Outriders</strong> (PC/Playstation5/Xbox Series; May 2021)
              <br />
              <strong>Rune 2</strong> (PC, Nov 2019)
              <br />
              <strong>Survived By</strong> (PC, Dec 2018)
            </MKTypography>
          </MKBox>
        </MKBox>

        <MKBox
          bgColor="#b2e5cb"
          borderRadius="xl"
          shadow="lg"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mt={{ xs: 10, sm: 10, md: 10 }}
          mb={{ xs: 10, sm: 10, md: 10 }}
          mx={3}
        >
          <MKBox
            variant="gradient"
            bgColor="info"
            coloredShadow="secondary"
            borderRadius="lg"
            p={2}
            mx={2}
            mt={-3}
          >
            <MKTypography
              variant="h1"
              color="background"
              sx={{ overflowWrap: "break-word", textAlign: "center" }}
            >
              Education
            </MKTypography>
          </MKBox>
          <MKBox p={3}>
            <MKTypography variant="body2" color="primary" mb={3}>
              <h3>Bachelor of Science in Software Engineering</h3>
              Milwaukee School of Engineering - Graduated 2016
            </MKTypography>
          </MKBox>
        </MKBox>
      </Grid>
    </>
  );
}

export default Portfolio;
